import { Amplify } from 'aws-amplify';

const configureAmplify = () => {
  const authConfig = {
    userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
    userPoolClientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
    loginWith: {
      email: true,
    },
  };

  if (process.env.REACT_APP_AWS_COGNITO_ENDPOINT) {
    authConfig.userPoolEndpoint = process.env.REACT_APP_AWS_COGNITO_ENDPOINT;
  }

  Amplify.configure({
    Auth: {
      Cognito: authConfig,
    },
  });
};

export default configureAmplify;
